import React from "react";

import cx from "classnames";

import styles from "./css/Tag.module.css";

export function Tag({ name, className }: { name: string; className?: string }) {
	return <span className={cx(styles.tag, className)}>{name}</span>;
}
